import { useQuery } from '@tanstack/react-query';

import {
  searchMetriportRecipients,
  searchNppesRecipients,
  type RecipientSearchParams,
} from '../api/searchReferralRecipients';

export const MIN_RECIPIENT_QUERY_LENGTH = 2;

/** A ZIP, or a prefix of at least two digits such as `911` or `911*`; empty means anywhere. */
export function isPostalFilter(postalCode: string): boolean {
  return postalCode === '' || /^\d{2,5}\*?$/.test(postalCode);
}

const referralRecipientKeys = {
  nppes: (params: RecipientSearchParams) => ['referral-recipients', 'nppes', params] as const,
  metriport: (params: RecipientSearchParams) =>
    ['referral-recipients', 'metriport', params] as const,
};

export function useNppesRecipientSearch(params: RecipientSearchParams, enabled = true) {
  return useQuery({
    queryKey: referralRecipientKeys.nppes(params),
    queryFn: ({ signal }) => searchNppesRecipients(params, signal),
    enabled:
      enabled &&
      params.query.trim().length >= MIN_RECIPIENT_QUERY_LENGTH &&
      isPostalFilter(params.postalCode),
    staleTime: 5 * 60_000,
  });
}

export function useMetriportRecipientSearch(params: RecipientSearchParams, enabled = true) {
  return useQuery({
    queryKey: referralRecipientKeys.metriport(params),
    queryFn: ({ signal }) => searchMetriportRecipients(params, signal),
    enabled:
      enabled &&
      params.query.trim().length >= MIN_RECIPIENT_QUERY_LENGTH &&
      isPostalFilter(params.postalCode),
    staleTime: 5 * 60_000,
  });
}
